export default __webpack_public_path__ + "static/media/icon_red_ambulatoria_on.f153cda3.svg";